export const mapProductIdToPlanId: { [key: string]: number } = {
    "com.avironactive.personal.annual": 1,
    "com.avironactive.personal.monthly": 2,
    "com.avironactive.family.annual": 3,
    "com.avironactive.family.monthly": 4,
};
